import styled from 'styled-components';

import { GetDeliveryQuery } from 'data/__generated__';

import { SectionContainer } from 'components/DetailsView/Section';
import { DataTable } from 'components/DataTable';

import { deliveryStockTransfersColumns, DeliveryStockTransferRow } from './constants/deliveryStockTransfersColumns';
import { ProductSummaryTable } from './components/ProductSummaryTable';

export const StockTransfersSection = ({ delivery }: { delivery: NonNullable<GetDeliveryQuery['delivery']> }) => {
    const { stockTransfers, stockTransfersProductSummary } = delivery;

    if (stockTransfers.length === 0) {
        return null;
    }

    return (
        <SectionContainer title={`Transferts de stock (${stockTransfers.length})`} isInitiallyOpen={false}>
            <Container>
                <Subtitle>Liste des transferts</Subtitle>
                <TableContainer style={{ height: Math.min(400, 110 + stockTransfers.length * 44) }}>
                    <DataTable<DeliveryStockTransferRow>
                        columns={deliveryStockTransfersColumns}
                        data={stockTransfers}
                        filterMode="client"
                        getRowId={(row) => row._id}
                        getRowLink={(row) => `/stock-transfer/${row._id}`}
                        searchPlaceholder="Colonne, date…"
                        searchFilterKey="searchValue"
                        disableUrlSync
                        disableColumnVisibility
                        autoFocusSearch={false}
                    />
                </TableContainer>
                <Subtitle>Récapitulatif par produit (demandé / positionné / soldouts)</Subtitle>
                <ProductSummaryTable summary={stockTransfersProductSummary} />
            </Container>
        </SectionContainer>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Subtitle = styled.div`
    font-weight: 700;
    margin-top: 5px;
`;

const TableContainer = styled.div`
    overflow: hidden;
`;
